'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Job = function Job(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("g", {
    id: "Group-6",
    transform: "translate(-6.000000, -6.000000)"
  }, React__default["default"].createElement("g", {
    id: "icon-/-ui-/-jobs",
    transform: "translate(4.000000, 4.000000)"
  }, React__default["default"].createElement("path", {
    d: "M21.7380793,18.3470584 L13.4777113,10.0366163 C14.2946708,7.93617491 13.8408044,5.47043934 12.1161122,3.73529209 C10.3006467,1.9088213 7.57744848,1.54352714 5.39888989,2.54808608 L9.3021407,6.47499828 L6.57894246,9.21470446 L2.58491838,5.28779226 C1.49563909,7.47955721 1.94950546,10.2192634 3.76497095,12.0457342 C5.48966317,13.7808814 7.94054158,14.2374991 10.0283269,13.4155873 L18.2886949,21.7260294 C18.651788,22.0913235 19.1964276,22.0913235 19.5595207,21.7260294 L21.6473061,19.625588 C22.1011724,19.2602938 22.1011724,18.621029 21.7380793,18.3470584 Z",
    id: "Path"
  }))));
};

var NavJobs = iconStyles()(Job);

module.exports = NavJobs;
